module.exports = __webpack_public_path__ + "img/nose_female_narrow.aca25e86.png";